import { stringify } from 'query-string';
import { useContext, useEffect, useState } from 'react';
import { Stage, Layer, Shape } from 'react-konva';
import fetchApi from '../../../api/fetchApi';
import { Context } from '../../../App';
import GeneralError from '../../../Components/ErrorBoundary/GeneralError';
import useSlug from '../../../shared/hooks/useLocation';
import './AboveViewCanvas.scss';

const status = {
    1: "Свободно",
    2: "Резерв",
    3: "Продано"
}

const apartTypes = {
    "flat": "Кв.",
    "parking": "Парк.",
    "storeroom": "Клад.",
    "commerce": "Оф.",
    "office": "Оф."
}

const MappedFloors = ({floors, apartments, setActive}) => {
    return floors?.map(({floor_id, number, availableCount, freeCount}, index) => {
        const isCommercial = window.location.pathname.includes("/commercial/");
        const flatType = Object.keys(freeCount).find((type) => {
            return Boolean(freeCount[type]);
    });

    const type = isCommercial ? "commerce" : flatType;
    const amount = freeCount[type]

    return (
        <div key={floor_id}>
            <input
                className="filter-floor__input"
                type="radio"
                name="floor"
                id={floor_id}
                data-id={floor_id}
                disabled={!amount}
                defaultChecked={!index && false}
            />
            <label className="filter-floor__item" htmlFor={floor_id}>
                <p className="filter-floor__value">{number}</p>
                <div className="filter-floor__status">
                    {
                        amount
                        ? `${ amount } ${ apartTypes[type] }`
                        : "Продано"
                    }
                </div>
                <span style={{display: "none"}}>
                    {JSON.stringify({freeCount, type, amount,isCommercial})}
                </span>
            </label>
        </div>
    );})
}

const MappedEntrances = ({plans, firstChecked}) => {
    return plans?.map(({number, entrance_id}) => {
        return (
            <div>
                <input
                    className="filter-entrance__input"
                    type="radio"
                    name="entrance"
                    id={entrance_id}
                    data-id={entrance_id}
                    checked={entrance_id == firstChecked && true}
                />
                <label className="filter-entrance__item" htmlFor={entrance_id}>
                    <p className="filter-entrance__value">{number}</p>
                </label>
            </div>
        );
    })
}



export default function AboveViewCanvas({setLoading, defaultEntrance, handleCurrentRoom}) {
    const {initialProps, facilityId} = useContext(Context);
    const [scaleFactor, setScaleFactor] = useState();
    const [hover, setHover] = useState();
    const [entranceId, setEntranceId] = useState(defaultEntrance);
    const [activeApartment, setActiveApartment] = useState();
    const [floors, setFloors] = useState([]);
    const [apartments, setApartments] = useState([]);
    const [image, setImage] = useState();
    const [rotate, setRotate] = useState(0);

    const isCommercial = useSlug();

    const fetchLayoutBlocks = async () => {
        setLoading(true);
        const facility_id = facilityId;
        const {json, error} = await fetchApi("sale/form?" + stringify({
            facility_id,
            entrance: entranceId,
            type: isCommercial() === "commercial" ? "commerce": ""
        }));

        setRotate(json.rot);
        setFloors(json.floors);
        setApartments(json.apartments);

        setLoading(false);
    }

    const handleEntranceChange = ({target}) => {
        setEntranceId(target.getAttribute("data-id"));
    }

    const handleFloorChange = ({target}) => {
        setActiveApartment(target.getAttribute("data-id"));
    }

    useEffect(() => {
        fetchLayoutBlocks();
    }, []);

    useEffect(() => {
        fetchLayoutBlocks();
    }, [entranceId]);

    useEffect(() => {
        if (!apartments[activeApartment]) {
            setImage();
        }
    }, [activeApartment])

    const activeFloor = floors.find(floor => floor.floor_id == activeApartment);
    const activeFloorType = Object.entries(activeFloor?.availableCount || {}).find(item => item[1] !== 0) || [];

    useEffect(() => {
        const {offsetWidth} = document.querySelector("#plan");
        if (offsetWidth > 950)
            setScaleFactor(1150 / 2300);
        if (offsetWidth < 951)
            setScaleFactor(offsetWidth / 1790);
    });


    return (
        <>
            <form className="room__filter-box show">
                <div className="filter-entrance">
                    <div className="filter-entrance__name">Подъезд</div>
                    <div className="filter-entrance__box" onChange={handleEntranceChange}>
                       <MappedEntrances
                            plans={initialProps.canvasPoints}
                            firstChecked={entranceId}
                        />
                    </div>
                </div>
                <div className="filter-floor">
                    <div className="filter-floor__name">Этажи</div>
                    <div className="filter-floor__box" onChange={handleFloorChange}>
                        <MappedFloors
                            setActive={setActiveApartment}
                            floors={floors}
                            apartments={apartments}
                        />
                    </div>
                </div>
            </form>
            {
                Array.isArray(apartments) &&
                    !apartments.length
                    ? <span>В выбранном подъезде отсутствуют свободные помещения</span>
                    : <span></span>
            }
            <div class="plan__icon">
                <svg
                    width={68}
                    height={72}
                    class="svg-icon icon-compass"
                    style={{transform: `rotate(${rotate}deg)`}}
                >
                    <use xlinkHref="/static/svg/sprite.svg#compass"></use>
                </svg>
            </div>
            <div id="plan">
                <Stage className="above-view-canvas" width={1150} height={650}>
                    <Layer className="plan__canvas">
                        {
                            apartments[activeApartment || apartments[0]?.floor_id] &&
                            apartments[activeApartment || apartments[0]?.floor_id].map((plan, key) =>
                                <Shape
                                    sceneFunc={(context, shape) => {
                                        const coords = JSON.parse(plan.path);
                                        context.beginPath();

                                        try {
                                            coords?.forEach(coord => {
                                                const x = coord[0] * scaleFactor;
                                                const y = coord[1] * scaleFactor;

                                                context.lineTo(x, y);
                                            });
                                        } catch {}

                                        context.closePath();
                                        context.fillStrokeShape(shape);
                                        setImage(floors?.find(({floor_id}) => floor_id == activeApartment)?.planning_image || "")
                                    }}
                                    fill={
                                        status[plan.status] !== "Продано"
                                        ? hover == key
                                            ? "#F40000"
                                            : plan.fill
                                        : ""
                                    }
                                    apartamentId={plan.apartament_id}
                                    onClick={() => {
                                        if (status[plan.status] !== "Продано") {
                                            handleCurrentRoom({id: plan.apartament_id, type: activeFloorType[0]})
                                        }
                                    }}
                                    onTouchEnd={() => {
                                        if (status[plan.status] !== "Продано") {
                                            handleCurrentRoom({id: plan.apartament_id, type: activeFloorType[0]})
                                        }
                                    }}
                                    onMouseMove={() => setHover(key)}
                                    onMouseOut={() => setHover()}
                                    key={key}
                                />
                            )
                        }
                    </Layer>
                </Stage>
                <img className="plan-image" src={image} alt="" />
                <GeneralError>
                {
                    apartments[activeApartment] &&
                    apartments[activeApartment].map((plan, key) => {
                        try {
                            const coords = JSON.parse(plan.path);

                            const coordsIsArray = Array.isArray(coords);
                            const arrayX = coordsIsArray ? coords?.map(point => point[0] * scaleFactor) : [];
                            let x = (Math.min(...arrayX) + Math.max(...arrayX)) / 2 - 15;

                            const arrayY = coordsIsArray ? coords.map(point => point[1] * scaleFactor) : [];
                            let y = (Math.min(...arrayY) + Math.max(...arrayY)) / 2;

                            const readyCoords = JSON.parse(plan.statusLabelCoords);

                            if (Array.isArray(readyCoords)) {
                                x = readyCoords[0] / 2 - 15;
                                y = readyCoords[1] / 2;
                            }

                            return (
                                <div
                                    className="popup-item hide"
                                    style={{position: "absolute", top: y, left: x, pointerEvents: "none"}}
                                    key={key}
                                >
                                    <span className={`popup-item__text status-${plan.status}`}>
                                        { status[plan.status] }
                                    </span>
                                    {
                                        status[plan.status] !== "Продано" &&
                                        <div className="popup-item__body" style={{display: hover == key && "block"}}>
                                            <div className="popup-item__head">
                                                <span className={`popup-item__text popup-item__text_inside status-${plan.status}`}>
                                                    { status[plan.status] }
                                                </span>
                                                <div className="popup-item__appartment">
                                                    <span>
                                                        { apartTypes[plan?.type] || "Помещение " }
                                                        №{plan.number}
                                                    </span>
                                                    {
                                                        plan.rooms
                                                        ? <span>
                                                            {
                                                                plan.rooms == 100
                                                                ? "Студия"
                                                                : `${plan.rooms}-комн.`
                                                            }
                                                            </span>
                                                        : ""
                                                    }
                                                    <span>{plan.floor} этаж</span>
                                                </div>
                                            </div>
                                            <div className="popup-item__info">
                                                <div>
                                                    <span>S общая</span>
                                                    <span>{plan.area} м²</span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            )
                        } catch {
                            return <></>
                        }
                    })
                }
                </GeneralError>
            </div>
        </>
    )
}
